<div class="flex flex-col items-center my-auto">
  @if (iconName) {
    <cds-svg-icon [autofill]="false" class="w-16 mb-8" name="{{iconName}}"></cds-svg-icon>
  }
  <h1 class="mb-2 text-center" [innerHTML]="header | translate"></h1>
  <p class="text-center">{{text | translate}}</p>
</div>
<div class="flex flex-col gap-2">
  @if (shareButton) {
    <app-share-button></app-share-button>
  }
  @if (secondButtonText) {
    <button cdsButton appRipple data-test="secondary-button" color="accent" size="small" class="w-full" (debounceClick)="onSecondBtnClick.emit()">
      {{ secondButtonText | translate }}
    </button>
  }
  @if (primaryButtonText) {
    <button cdsButton appRipple data-test="primary-button" color="primary" class="w-full" [size]="secondButtonText ? 'small' : 'big'" (debounceClick)="onPrimaryBtnClick.emit()">
      {{ primaryButtonText | translate }}
    </button>
  }
</div>
